import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { serviceItemSagaActions } from "../../Information/ServiceItem";
import { catalogueSagaActions } from "..";

import { Button, Card, Carousel, Row } from "react-bootstrap";
import { ArrowLeftCircleFill, ArrowRightCircleFill } from "react-bootstrap-icons";

import catalogStyles from "../css/Catalogue.module.css";
import carouselStyles from "../css/Carousel.module.css";
import "../css/Generic.css";
import { truncateText } from "../../../../utilities/lookup";


export const ServicesCatalogueCarousel = ({ services, servicesTotalCount, deptId, selectedProvince }) => {


  const uniqueId = "carousel-" + Math.random().toString(36).substr(2, 9);

  const history = useHistory();

  const dispatch = useDispatch();

  let columnCardsCount = 10; //set this to the number cards to be displayed in earch carousel item

  let dummyArray = Array(Math.ceil(servicesTotalCount / columnCardsCount)).fill(0);

  const handleServiceSelection = (service) => {

    let serviceId = service.id;
    let provId = selectedProvince.id;

    dispatch(serviceItemSagaActions.fetchAllServItemsForService(serviceId, deptId, provId));
    dispatch(catalogueSagaActions.setService(service));

    history.push({ pathname: "/catalogue-management/service-items" });

  };


  return (
    <>
      <style>
        {`
          .${uniqueId} .carousel-control-prev,
          .${uniqueId} .carousel-control-next {
            width: 40px !important;
            height: 40px !important;
            top: 50% !important;
            transform: translateY(-50%) !important;
            bottom: auto !important;
            background: none !important;
            border: none !important;
            opacity: 0.7;
            z-index: 10;
          }
 
        `}
      </style>
      <div className={uniqueId}>

        <Carousel
          prevIcon={<ArrowLeftCircleFill className={catalogStyles.carouselNavButton} color="#999" size={40} />}
          nextIcon={<ArrowRightCircleFill className={catalogStyles.carouselNavButton} color="#999" size={40} />}
          controls={servicesTotalCount > columnCardsCount ? true : false}
          indicators={true}
          interval={null} /* set to null to stop carousel from cycling */
        >
          {dummyArray.map((val, y) =>
            <Carousel.Item key={"yyy_" + y}>
              <Row>
                {services.slice(((y) * columnCardsCount), ((y + 1) * columnCardsCount)).map((service, z) =>
                  <div className='col-xxl-4 col-md-6 col-sm-12 d-lg-flex d-md-flex d-sm-flex' key={"zzz_" + z}>
                    <Card className={`${carouselStyles.carouselCardNoImage} w-100 mb-10`} >
                      <Card.Body className={`${carouselStyles.cardBody}`}>
                        <Card.Title>
                          <span title={service.name}>{truncateText(service.name, 25)}</span>
                          <hr />
                        </Card.Title>

                        <Card.Text>
                          <span title={service.description} style={{ fontSize: "1rem", display: "block" }}>
                            <b>Description:</b> <br />
                            {truncateText(service.description, 25)}
                          </span>
                        </Card.Text>
                        <Button className={`${carouselStyles.cardBodyButton}`} variant="primary" onClick={() => handleServiceSelection(service)}>View Service Items</Button>
                      </Card.Body>
                    </Card>
                  </div>
                )}
              </Row>
            </Carousel.Item>
          )}
        </Carousel>
      </div>
    </>
  );
};
